import { DetailTable } from '../../../mapping-classes/detail-table';

export class Mandates implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(mandates: any) {
    if (!mandates) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(mandates);
    }
  }

  createErrorMessage() {
    this.errorText = '';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'incassant',
      'machtiging',
      'omscrijving',
      'datumIngevoerd',
      'soort',
      'maxBedrag',
      'status',
      'laatsteDatumBedrag',
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
      this.rowData.push(details);
    });
  }
}
